import { useTranslate } from '@refinedev/core';
import { Card, Descriptions, Typography } from 'antd';
import type { DescriptionsProps } from 'antd';
import type { ContentDistributionPeriodDetailOut } from '@/api/generated/schemas';
import { ModStatusTag } from '@/components/common/ModStatusTag';
import { orDash, useVerticalDescProps } from '@/components/common/show/shared';
import { PublicationLazyCell } from '@/components/user_catalog/publications/PublicationLazyCell';

interface DistributionPeriodUserCatalogCardProps {
  record: ContentDistributionPeriodDetailOut;
}

/** Sidebar: how this period is reflected in the user catalog. */
export const DistributionPeriodUserCatalogCard = ({
  record,
}: DistributionPeriodUserCatalogCardProps) => {
  const t = useTranslate();
  const verticalDescProps = useVerticalDescProps();
  const f = (key: string) =>
    t(`content_catalog.distribution_periods.fields.${key}`);

  const items: DescriptionsProps['items'] = [
    {
      key: 'publication',
      label: f('user_catalog_publication_id'),
      children:
        record.user_catalog_publication_id != null ? (
          <PublicationLazyCell
            publicationId={record.user_catalog_publication_id}
            title={record.user_catalog_publication_title}
            coverUrl={record.user_catalog_publication_cover_url}
            size={56}
          />
        ) : (
          <Typography.Text type="secondary">
            {t('content_catalog.distribution_periods.alerts.not_imported')}
          </Typography.Text>
        ),
    },
    {
      key: 'mod_status',
      label: f('user_catalog_publication_mod_status'),
      children: orDash(
        record.user_catalog_publication_mod_status && (
          <ModStatusTag value={record.user_catalog_publication_mod_status} />
        )
      ),
    },
    {
      key: 'product_mod_status',
      label: f('user_catalog_product_mod_status'),
      children: orDash(
        record.user_catalog_product_mod_status && (
          <ModStatusTag value={record.user_catalog_product_mod_status} />
        )
      ),
    },
  ];

  return (
    <Card title={t('content_catalog.distribution_periods.show.user_catalog')}>
      <Descriptions {...verticalDescProps} column={1} items={items} />
    </Card>
  );
};
